// extracted by mini-css-extract-plugin
export var container = "_c1-0";
export var content = "_c1-3";
export var customerTitle = "_c1-4";
export var empty = "_c1-5";
export var gray = "_c1-6";
export var header = "_c1-7";
export var info = "_c1-8";
export var loading = "_c1-2";
export var loadingCard = "_c1-9";
export var oneLine = "_c1-a";
export var personName = "_c1-e";
export var pillContainer = "_c1-b";
export var selected = "_c1-1";
export var text = "_c1-c";
export var twoLines = "_c1-d";
export var unread = "_c1-f";
export var unreadIndicator = "_c1-g";